import Common from "../../../../Shared/Common";

const MemsAPI = {

    getOTP: async function (inputParmaeter, callbackMethod, callbackData, callbackErrorMethod) {
        Common.call("api/Clubs/getPucko", inputParmaeter, callbackMethod, callbackData, callbackErrorMethod);
    }
};
export default MemsAPI;

